import React, { useEffect, useRef, useState } from "react";
import styles from "../mobilesignup2style.module.css";
import { Button, CircularProgress, TextField } from "@mui/material";
import { getFetch, postFetch } from "../../../fetch/fetch";


const GetRegistCode: React.FC<any> = (props) => {

    const [disabled, setDisabled] = useState(true);
    const inputRef = useRef<HTMLInputElement>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        setDisabled(!props.registerPassword);

        //value가 학생이면 4개면 blur시키고 제출
        //value가 Teacher면 8개면 blur시키고 제출
        if(props.value === "student" ){
            if(props.registerPassword && props.registerPassword.length === 4){
                inputRef.current?.blur();
                submit();
            }
        }

        if(props.value === "teacher" ){
            if(props.registerPassword && props.registerPassword.length === 8){
                inputRef.current?.blur();
                submit();
            }
        }

    }, [props.registerPassword, props.value, inputRef.current]);

    const controlChange = (raw: string) => {

        if (!props.setRegisterPassword) {
            return;
        }

        props.setRegisterPassword(raw);

    };


    //처음에 focus 처리
    useEffect(() => {
        if (inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, [inputRef.current]);

    const submit = async () => {
        try{

            setLoading(true);

            const result = await props.submit();

            setLoading(false);

        }catch(e){
            console.log(e);
        }
    }


    return (
        <div className={styles.mainContainer} style={{
            height: props.bodyHeight ? `${props.bodyHeight}px` : "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: props.pc ? "" : "space-between",
            // paddingBottom: "39px",
            paddingBottom : props.pc ? "" : "max(var(--safe-area-inset-bottom), 39px)",
        }}>
            <div style={{
                width: "100%",
                marginBottom : props.pc ? "30px" : "0px"
            }}>
                <div style={{
                    paddingTop: "28px",
                    color: "#202632",
                    fontFamily: "Apple_B",
                    fontSize: "24px",
                    lineHeight: "32px",
                    letterSpacing: "-2%",
                }}>
                    <br />가입용 코드를 입력해주세요
                </div>
                <div style={{
                    marginTop: "40px"
                }}>
                    <div>
                        <TextField
                            variant="standard"
                            label="가입 코드"
                            fullWidth
                            type="tel"
                            sx={{
                                "& .MuiInput-underline::before": {
                                    borderBottom: "1px solid #d3d3d3"
                                },
                                "& .MuiInput-underline": {
                                    height: "40px"
                                },
                                "& .MuiInputBase-input::placeholder": {
                                    fontFamily: "Apple_SB",
                                    color: "#d3d3d3"
                                },
                                "& .MuiInputBase-input": {
                                    fontFamily: "Apple_SB",
                                    color: "#202632",
                                    fontSize: "20px"
                                },
                            }}
                            value={props.registerPassword ? props.registerPassword : ""}
                            onChange={(e) => controlChange(e.target.value)}
                            inputRef={inputRef}
                        />
                    </div>
                </div>
            </div>
            <div>
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#3d50b0",
                        height: "52px",
                        borderRadius: "13px",
                        fontWeight: 500,
                        fontFamily: "Apple_R",
                        boxShadow: "none !important",
                        '&.Mui-disabled': {
                            backgroundColor: '#C1d6f3',
                            color: "white"
                        },
                        "&:hover": {
                            backgroundColor: "#3d50b0",
                            boxShadow: "none",
                        },

                        "&:active": {
                            backgroundColor: "#3d50b0",
                        },

                        "&.Mui-focusVisible": {
                            backgroundColor: "#3d50b0",
                        }
                    }}
                    fullWidth
                    disabled={disabled}
                    onClick={() => {
                        submit();
                    }}
                >
                    {
                        !loading ?
                            "제출하기"
                            :
                            <CircularProgress size={24} style={{ color: "white" }} />
                    }
                </Button>
            </div>


        </div>
    )
}

export default GetRegistCode;